// extracted by mini-css-extract-plugin
export default {"container":"_1qaXQ","desktopContainer":"esy1Y","label":"q9OqU","list":"Bdi96","listExpanded":"_2+kEe"};